import React from 'react';
import moment from 'moment';
import styles from './Footer.module.css';

const Footer = () => {
  const currentYear = moment().format('YYYY');
  return <div className={styles.footer}>
    <span className={styles.footerText}>
      Copyright {currentYear} <span className={styles.companyName}>Tata Motors</span>.
      All rights reserved
    </span>
  </div>
};

export default Footer;